var parseNumberByPrecision = function (num1, num2, precision) {
    var _a, _b;
    if (precision === void 0) { precision = 2; }
    var re = new RegExp("^-?\\d+(?:.\\d{0,".concat(precision, "})?"));
    var digitsAfterDotAtNum1 = ((_a = num1.toString().split('.')[1]) === null || _a === void 0 ? void 0 : _a.length) || 0;
    var digitsAfterDotAtNum2 = ((_b = num2.toString().split('.')[1]) === null || _b === void 0 ? void 0 : _b.length) || 0;
    var digitsCountAfterDot = digitsAfterDotAtNum2 + digitsAfterDotAtNum1;
    var result;
    var numMulti = (Math.round(num1 * Math.pow(10, digitsCountAfterDot)) *
        Math.round(num2 * Math.pow(10, digitsCountAfterDot))) /
        Math.pow(10, (digitsCountAfterDot + digitsCountAfterDot));
    result = numMulti.toString().match(re) && +numMulti.toString().match(re)[0];
    return result;
};

export { parseNumberByPrecision };
